import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Page from "components/base/Page";
import Spinner from "components/base/Spinner";
import moment from "moment";
import { Link } from "react-router-dom";
import { AI_CONVERSATIONS } from "./graphql";

const HistoryPage = () => {
  const { loading, error, data } = useQuery(AI_CONVERSATIONS, {
    fetchPolicy: "network-only",
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  const conversations = data.aiConversations || [];

  return (
    <Page title="History" backTo="/ai/ask" className="font-code">
      <div className="p-6">
        {conversations.length === 0 ? (
          <div className="opacity-70">No conversation history yet.</div>
        ) : (
          <div className="divide-y dark:divide-gray-700">
            {conversations.map((conversation) => (
              <div key={conversation.id} className="py-3">
                <Link to={`/ai/ask/${conversation.id}`}>
                  {conversation.title || "Untitled conversation"}
                </Link>

                <div className="text-xs opacity-70 mt-1">
                  {conversation.user?.email} {conversation.messageCount}{" "}
                  messages • Updated{" "}
                  {moment(conversation.updatedAt).format("YYYY-MM-DD HH:mm:ss")}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Page>
  );
};

export default HistoryPage;
